// Module
var code = "<p class=emptyMessage style=text-align:center>No new notifications</p> ";
// Exports
module.exports = code;